<template>
  <div class="flex items-center gap-2 flex-wrap justify-center">
    <u-text
      class="font-bold text-body"
      color="type-secondary"
      text="Excellent"
    />
    <div class="flex">
      <v-icon
        v-for="n in 4"
        :key="n"
        icon="star-fill"
        size="20"
        color="primary-teal"
      />
      <v-icon
        icon="star-half-fill"
        size="20"
        color="primary-teal"
      />
    </div>
    <u-text
      class="font-bold text-body"
      color="type-secondary"
    >
      4.4
    </u-text>
    <u-text
      class="text-body-xxs"
      color="type-secondary"
    >
      based on 11,500+ reviews
    </u-text>
  </div>
</template>

<script setup lang="ts">
</script>
